import * as Yup from 'yup';
import { Formik } from 'formik';

import { ButtonStyleTypes } from 'types';
import { Event, useAcceptMutation } from 'store/api/event';
import { isMobile, isDesktop, handleMutation } from 'hooks';
import {
  List,
  Dialog,
  Button,
  Checkbox,
  ListHeader,
  DialogType,
  ButtonTypes,
  CommonStyles,
  ButtonWithRef,
  LocationListCard,
} from 'components';

const template = '24px repeat(5, 1fr)';
const titles = ['', '#', '$', 'Size', 'Type', 'Event Type'];

export const AcceptEventDialog = ({ event }: { event: Event }) => {
  const mobile = isMobile();
  const desktop = isDesktop();
  const [accept, acceptMutation] = useAcceptMutation();

  handleMutation({
    ...acceptMutation,
    successMessage: 'Event accepted',
  });

  const currentTitles = desktop ? titles : ['Select', ...titles];

  return (
    <Dialog
      title="Accept event"
      width={mobile ? '90vw' : '720px'}
      trigger={
        <ButtonWithRef text="Accept event" style={{ width: 'fit-content' }} />
      }
    >
      {(close, _, ButtonsComponent) => (
        <Formik
          onSubmit={(values) => accept({ id: event.id, ...values })}
          initialValues={{
            locationIds: [],
          }}
          validationSchema={Yup.object().shape({
            locationIds: Yup.array().min(1).required(),
          })}
        >
          {({ dirty, values, isSubmitting, setFieldValue }) => (
            <CommonStyles.Form>
              <List
                count={event.locations.length}
                mainWrapperStyles={{ padding: 0 }}
                header={
                  <ListHeader
                    padding="8px"
                    template={template}
                    titles={currentTitles}
                  />
                }
              >
                {event.locations.map((value) => (
                  <LocationListCard
                    key={value.id}
                    location={value}
                    template={template}
                    titles={currentTitles}
                    extendedValues={[
                      <Checkbox
                        checked={values.locationIds.find(
                          (locationId) => locationId === value.id
                        )}
                        onChange={(e) => {
                          if (e.target.checked) {
                            return setFieldValue('locationIds', [
                              ...values.locationIds,
                              value.id,
                            ]);
                          }

                          setFieldValue(
                            'locationIds',
                            values.locationIds.filter(
                              (locationId) => locationId !== value.id
                            )
                          );
                        }}
                      />,
                    ]}
                  />
                ))}
              </List>

              <ButtonsComponent type={DialogType.Plain}>
                <Button
                  text="Cancel"
                  onClick={close}
                  styleType={ButtonStyleTypes.Outline}
                />

                <Button
                  text="Confirm"
                  type={ButtonTypes.Submit}
                  disabled={!dirty || isSubmitting}
                />
              </ButtonsComponent>
            </CommonStyles.Form>
          )}
        </Formik>
      )}
    </Dialog>
  );
};
